import { make } from "vuex-pathify";

// properties
const state = {
  items: [],
};
const mutations = make.mutations(state);
const getters = {
  ...make.getters(state),
};
const actions = {};

export default {
  firestorePath: "listLibrary",
  firestoreRefType: "collection",
  moduleName: "list-library",
  statePropName: "items",
  sync: {
    preventInitialDocInsertion: true,
    defaultValues: {
      status: "published",
      version: 1,
    },
  },
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
